import types from './actionTypes';

const initialState = {
  loading: false,
  loadingMessages: false,
  aiConversations: [],
  messages: [],
  error: '',
};

const aiConversationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_AI_CONVERSATION_STATE:
      return { ...initialState };

    case types.FETCH_AI_CONVERSATIONS_BY_LEAD.REQUEST:
      // Another lead's conversations must not stay on screen under this
      // lead's name. The component shows its loading and error views only
      // while the list is empty, so leaving the previous ones here means
      // showing them as if they were hers — and going on showing them if the
      // new read fails.
      return {
        ...state,
        loading: true,
        error: '',
        aiConversations: [],
        messages: [],
      };

    case types.STOP_AI_CONVERSATION.REQUEST:
      // The stop acts on the conversation being looked at: emptying the list
      // here would blank the modal the operator is working in.
      return { ...state, loading: true, error: '' };

    case types.FETCH_AI_CONVERSATION_MESSAGES.REQUEST:
      // Its own flag: the conversations stay on screen while the messages of
      // the selected one are being read, instead of the modal going blank.
      // The previous transcript does not: if this read fails, the modal shows
      // its error only over an empty transcript, and would otherwise show
      // the other conversation's messages under this one's summary.
      return { ...state, loadingMessages: true, messages: [], error: '' };

    case types.FETCH_AI_CONVERSATIONS_BY_LEAD.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        aiConversations: [...action.aiConversations],
      };

    case types.FETCH_AI_CONVERSATION_MESSAGES.SUCCESS:
      return {
        ...state,
        loadingMessages: false,
        error: '',
        messages: [...action.messages],
      };

    case types.STOP_AI_CONVERSATION.SUCCESS:
      return { ...state, loading: false, error: '' };

    case types.FETCH_AI_CONVERSATION_MESSAGES.FAILURE:
      return { ...state, loadingMessages: false, error: action.error.message };

    case types.FETCH_AI_CONVERSATIONS_BY_LEAD.FAILURE:
    case types.STOP_AI_CONVERSATION.FAILURE:
      return { ...state, loading: false, error: action.error.message };

    default:
      return state;
  }
};

export default aiConversationReducer;
